<template>
  <div class="container-custom">
    <!-- BreadScrumbs -->
    <BreadScrumbs
      :links="[{ name: 'Dividend History', to: { path: '/dividend-history' } }]"
    ></BreadScrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>Dividend History</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="createHandler">
        <v-icon class="pr-2 white--text">add</v-icon>
        <span>新增</span>
      </button>
    </div>
    <!--  -->
    <DividendHistoryTable class="mb-5"></DividendHistoryTable>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BreadScrumbs from '@/components/Breadscrumbs.vue';
import DividendHistoryTable from '@/views/I-4__IR-DividendHistoryCreate/c/DividendHistoryTable.vue';

export default {
  components: {
    BreadScrumbs,
    DividendHistoryTable,
  },
  created() {
    this.clear();
    this.getShareholderDividendHistories();
  },
  methods: {
    ...mapActions('shareholderDividendHistory', {
      getShareholderDividendHistories: 'find',
      clear: 'clear',
    }),
    createHandler() {
      this.$router.push('/dividend-history/create');
    },
    toEditPageTitle() {
      this.$router.push('/dividend-history/edit-dividend-history-page-title');
    },
  },
};
</script>

<style></style>
